import React, { useState } from 'react';
import { Button, Card, Tab } from 'react-bootstrap';

import Tabs from '../../../app/components/Tabs';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import {
  CreateUpdatePricingGroupDto,
  GetPricingGroupDto,
  ResponseError,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import {
  pricingGroupData,
  validate,
} from '../../../common/spdCore/contexts/PricingGroupContext';
import { PricingGroupSearch } from '../../components/PricingGroup/PricingGroupSearch';
import { PricingGroupEditor } from '../../components/PricingGroup/PricingGroupEditor';

export const PricingGroupView: React.FC = () => {
  const spd = useSpdCore();
  const [show, setShow] = useState(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [supportingExamDict, setSupportingExamDict] =
    useState<GetPricingGroupDto>();

  const handleAdd = () => {
    setShow(true);
    setSupportingExamDict(undefined);
  };

  const handleClose = () => {
    setShow(false);
    setRefresh(!refresh);
  };

  const addEditPricingGroup = async (
    hfCu: CreateUpdatePricingGroupDto,
    id?: string,
  ) => {
    const status = await validate(hfCu);
    if (status.valid) {
      try {
        if (id) {
          await spd.pricingGroups.update(id, hfCu);
        } else {
          await spd.pricingGroups.create(hfCu);
        }
        setShow(false);
        setRefresh(!refresh);
        return {
          saved: true,
          errors: [],
        };
      } catch (response) {
        return {
          saved: false,
          errors: await responseErrors(response as ResponseError),
        };
      }
    } else {
      return {
        saved: false,
        errors: status.errors,
      };
    }
  };

  const onRowClick = async (id: string) => {
    const getHF = await spd.pricingGroups.get(id);
    setSupportingExamDict(getHF);
    setShow(true);
  };

  return (
    <Card>
      <Tabs defaultActiveKey="search" id="pricingGroup" className="mb-3">
        <Tab eventKey="search" title="Grupy cenowe" className="m-3">
          <PricingGroupSearch
            getData={spd.pricingGroups.getAllByPortion}
            getCount={spd.pricingGroups.getAllCount}
            refresh={refresh}
            onRowClick={onRowClick}
          />
          <Button variant="outline-primary" onClick={handleAdd}>
            Nowa grupa cenowa
          </Button>
          <PricingGroupEditor
            id={supportingExamDict?.id}
            pricingGroup={pricingGroupData(supportingExamDict)}
            onCompleted={addEditPricingGroup}
            show={show}
            handleClose={handleClose}
          />
        </Tab>
      </Tabs>
    </Card>
  );
};
